module.exports = __webpack_public_path__ + "static/media/是否知道住家附近的政府公告避難地點vs有沒有至空曠處避難.cf1d1fed.png";